import { ReactNode } from 'react'

import Footer from '../components/Footer'
import Nav from '../components/Nav'

interface Props {
  children?: ReactNode
}

const Layout = ({ children }: Props) => {
  return (
    <div className='min-h-screen bg-gray-900 text-gray-200 flex flex-col'>
      <Nav />
      <main className='flex-1'>
        <div className='max-w-6xl container mx-auto px-4 sm:px-6 lg:px-8'>{children}</div>
      </main>
      <Footer />
    </div>
  )
}

export default Layout
